// @core/api/endpoints/booking/respond_to_review.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingReviewResponse,
  RespondToReviewRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Respond to review
 * Provider adds a public response to a customer review.
 */
export async function RespondToReview(
  review_id: string,
  data: RespondToReviewRequest,
  options?: RequestOptions
): Promise<BookingReviewResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/reviews/:review_id/respond`;
  requestPath = requestPath.replace(':review_id', encodeURIComponent(review_id));
  const requestOptions = options;
  return client.post<BookingReviewResponse>(requestPath, data, requestOptions);
}
